import { render, staticRenderFns } from "./tariff-detail.vue?vue&type=template&id=7f8fba8a&scoped=true&"
import script from "./tariff-detail.vue?vue&type=script&lang=js&"
export * from "./tariff-detail.vue?vue&type=script&lang=js&"
import style0 from "./tariff-detail.vue?vue&type=style&index=0&id=7f8fba8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8fba8a",
  null
  
)

export default component.exports